import { iSupplier } from "@sdk/suppliers/supplier-model";
import { iStore } from "../../store.model";
import { CreateSelectorForEntities } from "../../utils/entity-slice-creator";

export const {
  selectQueryMap: selectSupplierQueryMap,
  selectEntityMap: selectSuppliersMap,
  selectQueryMapAll: selectSuppliersMapAll,
  selectQueryAllList: selectSuppliersAllList,
  selectAllEntities: selectAllSuppliers,
  selectAllEntitiesQuery: selectAllSuppliersQuery,
  selectEntityById: selectSupplierById,
  selectEntityQuery: selectSupplierQuery,
  selectEntityQueryList: selectSupplierQueryList,
} = CreateSelectorForEntities<iStore, iSupplier>({
  sliceName: "suppliers",
});
